import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TaskDossier\FetchTaskDossierGroupPageController::__invoke
* @see app/Http/Controllers/TaskDossier/FetchTaskDossierGroupPageController.php
* @route '/api/fetch-dossier-tasks/page'
*/
const FetchTaskDossierGroupPageController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchTaskDossierGroupPageController.url(options),
    method: 'post',
})

FetchTaskDossierGroupPageController.definition = {
    methods: ["post"],
    url: '/api/fetch-dossier-tasks/page',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\TaskDossier\FetchTaskDossierGroupPageController::__invoke
* @see app/Http/Controllers/TaskDossier/FetchTaskDossierGroupPageController.php
* @route '/api/fetch-dossier-tasks/page'
*/
FetchTaskDossierGroupPageController.url = (options?: RouteQueryOptions) => {
    return FetchTaskDossierGroupPageController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\TaskDossier\FetchTaskDossierGroupPageController::__invoke
* @see app/Http/Controllers/TaskDossier/FetchTaskDossierGroupPageController.php
* @route '/api/fetch-dossier-tasks/page'
*/
FetchTaskDossierGroupPageController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchTaskDossierGroupPageController.url(options),
    method: 'post',
})

export default FetchTaskDossierGroupPageController